module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-11-92d35ef38cffbccb158228b528d5932e.jpg";